<template>
    <div class="elichain-about">
        <div class="header-wrapper">
            <div class="header">
                <div class="logo">
                    <img src="../../assets/about_logo.png">
                </div>
                <div class="remark">
                    <div class="title">慕鹿 Elichian</div>
                    <div class="desc">科技改变未来   只因我们都在</div>
                </div>
            </div>
            <img src="../../assets/HedaerWave.png" class="wave_bg">
        </div>
        <div class="info">
            <div class="title">
                <div class="tit">慕鹿是什么</div>
                <div class="txt">What Is This</div>
            </div>
            <div class="desc">
                慕鹿平台，是杭州乔金斯科技集团有限公司软件技术研发中心团队为乔金斯打造的互联网生态平台，以多维度管理及服务一体化平台、整合大系统建立乔金斯生态链的大数据，通过大数据来提升乔金斯的服务、品质、设计，增强乔金斯的品牌效应。<br>
                慕鹿整合了乔金斯所有平台及系统，建立庞大的生态数据池，根据不同需求，提供不同的数据库及运营工具，通过平台对门店及内部的服务管控，增强学习培训，提高乔金斯服务质量，通过对售后数据的积累，更快的能分析出品质问题出在哪，也能更好的做出预估，平台处理业务过程中，将自动沉淀用户及设计数据，以及提供外部数据分享， 建立市场资源库，可更好的分析出设计方面的市场走向。
                项目以多维度管理及服务一体化平台、整合大系统建立乔金斯生态链的大数据，通过大数据来提升乔金斯的服务、品质、设计，增强乔金斯的品牌效应，为大家居、 大健康、大教育方向埋下重要的伏笔。
            </div>
            <div class="title">
                <div class="tit">慕鹿名字由来</div>
                <div class="txt">The Origin Of The Name</div>
            </div>
            <div class="desc">
              “慕”为思念、思想的意思， “鹿”象征着健康、幸福、吉祥，是美好生活的体现，代表着我们想要实现美好生活的憧憬。“慕鹿” 音译“目录”，指的是书籍的第一页，是揭示和报道图书的工具，也是记录图书的书名、著者、出版与收藏等情况。“鹿”象征着健康、幸福、吉祥，是美好生活的体现。我们的根本就是以整木定制去帮助客户实现美好生活，代表着乔金斯生态的目录，也是代表着美好生活的目录，更形容着乔金斯里每一个人都是美好生活这本书的撰写者，而客户就是这本书的阅读者。
            </div>
            <div class="title">
                <div class="tit">Elichain是什么</div>
                <div class="txt">What Is Elichain</div>
            </div>
            <div class="desc">
                Elichain是慕鹿生态平台的英文标识，“elichain”所属南非科萨语，词意为“链”，“e”是互联网的代表，“lic”是许可证执照的意思，“chain”指的是生态链，“elichain”代表着乔金斯互联网生态链的一种标志。
            </div>
            <div class="title">
                <div class="tit">TCF 团队介绍</div>
                <div class="txt">Team Introduction</div>
            </div>
            <div class="user-info">
                <div class="name">
                    <div class="photo">
                        <img src="../../assets/yangming.jpg">
                    </div>
                    <span>杨名</span>
                    <div class="txt">技术总监/全栈开发</div>
                </div>
            </div>
            <div class="user-info">
                <div class="name">
                    <div class="photo">
                        <img src="../../assets/wangyuxin.jpg">
                    </div>
                    <span>王玉鑫</span>
                    <div class="txt">项目经理/全栈开发</div>
                </div>
            </div>
            <div class="user-info">
                <div class="name">
                    <div class="photo">
                        <img src="../../assets/liuzhigao.jpg">
                    </div>
                    <span>刘志高</span>
                    <div class="txt">IOS高级开发</div>
                </div>
            </div>
            <div class="user-info">
                <div class="name">
                    <div class="photo">
                        <img src="../../assets/yinxiangwen.jpg">
                    </div>
                    <span>殷想文</span>
                    <div class="txt">Android高级开发</div>
                </div>
            </div>
          <div class="user-info">
            <div class="name">
              <div class="photo">
                <img src="../../assets/gaoxiaojin.jpg">
              </div>
              <span>高小金</span>
              <div class="txt">Java高级开发</div>
            </div>
          </div>
          <div class="user-info">
            <div class="name">
              <div class="photo">
                <img src="../../assets/zhangjinyang.jpg">
              </div>
              <span>张金阳</span>
              <div class="txt">Java高级开发</div>
            </div>
          </div>
            <div class="desc">
                一直以来，我们秉承用科技改变未来的初心，虔诚致力于服务乔金斯各事业部门以及经销商，在互联网科技横飞的当今时代，这一信念从未动摇。即便身单力薄，仍然重拾决心，埋头造轮，以尽可能地填补平台与服务本身的缺口。
                <span style="float: right;">TCF Technology Changes Future</span>
            </div>
            <div class="title">
                <div class="tit">联系我们</div>
                <div class="txt">Contact Us</div>
            </div>
            <div class="desc">
                <img src="../../assets/about_qrcode_mulu.jpg" style="width: 60%;"><br>
                联系电话：18067938823<br>
                电子邮箱：jokinsmulu@163.com<br>
                慕鹿官网：www.mulu.life<br>
                所在地址：杭州市滨江区阿里中心3号楼705室
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "Elichain",
  created() {
    document.title = 'Elichain'
  },
}
</script>
<style lang="scss" scoped>
.elichain-about{
  width: 100%;
  padding: 20px 0;
  position: relative;
  box-sizing: border-box;
  font-weight: 400;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
.header-wrapper{
  position: relative;
  height: 280px;
.header {
  width: 100%;
  padding-left: 60px;
  padding-right: 60px;
  margin: 0 auto;
  text-align: center;
  padding-top: 50px;
  box-sizing: border-box;
.logo {
  width: 100%;
  position: relative;
  text-align: center;
img {
  height: 80px;
}
}
.remark {
  width: 100%;
  position: relative;
  text-align: center;
.title {
  font-size: 22px;
  font-weight: 400;
  color: #000000;
  letter-spacing: 2px;
}
.desc {
  font-size: 14px;
  font-weight: 400;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  color: #222222;
  letter-spacing: 4px;
  padding: 10px 0;
}
}
}
.wave_bg {
  width: 100%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  left: 50%;
  position: absolute;
  bottom: 0;
}
}
.info{
  width: 100%;
  position: relative;
  padding: 0 30px;
  margin-top: 50px;
  box-sizing: border-box;
.title{
  width: 100%;
  margin-bottom: 20px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
.tit{
  font-size: 16px;
  font-weight: 500;
  color:#292b2c;
  letter-spacing: 1px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}
.txt{
  font-size: 12px;
  color:#99a9bf;
  font-weight: 400;
  letter-spacing: 1px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}
}
.desc{
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  font-size: 13px;
  line-height: 26px;
  margin-bottom: 50px;
  letter-spacing: 1px;
}
.user-info{
  width: 100%;
  position: relative;
  margin-bottom: 20px;
.name{
  width: 100%;
  height: 50px;
  padding-left: 60px;
  font-size: 12px;
  font-weight: 400;
  box-sizing: border-box;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
.photo{
  position: absolute;
  top: 0;
  left: 0;
img{
  width: 50px;
  border-radius: 4px;
}
}
span{
  font-size: 16px;
  color:#000;
}
.txt{
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  color:#909399;
}
}
.desc{
  border-top: 1px solid #f5f7fa;
  margin-top: 10px;
  padding-top: 10px;
  box-sizing: border-box;
}
}
}
}
</style>
